const splitValue = (value: string) => {
  const [integer, afterDecimal] = value.split('.');
  return { integer, afterDecimal };
};

export default splitValue;
